export const createNotificationSlice = (set) => ({
  notification: null,
  setNotification: (notification) => set(() => ({ notification: notification })),
  clearNotification: () => set(() => ({ notification: null })),
})